import ColumnText from "../molecules/ColumnText";
import { Fragment } from "react";
import { Empty } from "./Empty";
import { t } from "i18next";
import { RegistrationPayment } from "@/app/registration-payments/registration-payments";

export type TableListMatriculaProps = {
  registrationPayments: Array<RegistrationPayment>;
  onEdit: (registrationPayment: RegistrationPayment) => void;
};

const TableListMatricula: React.FC<TableListMatriculaProps> = ({
  registrationPayments,
  onEdit,
}) => {
  return (
    <div className="">
      <div className="border-b border-gray-300 mt-5"></div>
      <div className="flow-root">
        {/* Añadir un contenedor con scroll */}
        <div className="overflow-x-auto max-h-[60vh]">
          <div className="inline-block min-w-full align-middle">
            {registrationPayments.length === 0 ? (
              <Empty
                texto={t("customer-to-gym-subscription.views.no_registration")}
              />
            ) : (
              <Fragment>
                <table className="min-w-full divide-y divide-gray-300">
                  <thead>
                    <tr>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        {t("customer-to-gym-subscription.views.description")}
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        {t("customer-to-gym-subscription.views.price")}
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200 bg-white">
                    {registrationPayments.map((registrationPayment) => (
                      <tr key={registrationPayment.id}>
                        <ColumnText title={registrationPayment.name} />
                        <ColumnText
                          title={`${registrationPayment.currency.toUpperCase()} ${registrationPayment.price}`}
                        />
                        <td className="relative whitespace-nowrap py-5 pl-3 pr-4 text-right text-sm font-medium sm:pr-0">
                          <a
                            onClick={() => onEdit(registrationPayment)}
                            href="#"
                            className="text-primary-500 hover:text-primary-900 mr-4"
                          >
                            {t("general.edit")}
                          </a>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Fragment>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TableListMatricula;
